<template>
  <div style="font-size: 11px;">
    <v-select
      class="additionals"
      v-model="selectedItems"
      item-value="internalID"
      :items="additionalCharges"
      outlined
      :label="label"
      dense
      :height="28"
      hide-details
      multiple
      @change="getCostEstimate"
    >
      <template v-slot:selection="{ item, index }">
        <span style="font-size: 12px;">{{ item.name }},&nbsp;</span>
      </template>
      <template v-slot:item="{ item, index }">
        <span style="font-size: 12px;">{{ item.name }}</span>
      </template>
    </v-select>
  </div>
</template>

<script>
export default {
  name: "BookingAdditionalChargeSummary",
  props: {
    booking: Object,
    label: {
      type: String,
      default: "Additional Charges"
    }
  },
  computed: {
    additionalCharges: function() {
      return this.booking.bookingAdditionalCharges;
    }
  },
  watch: {
    "booking.bookingAdditionalCharges": function() {
      console.log("Calculating Selected");
      this.calculateSelected();
    }
  },
  mounted: function() {
    this.calculateSelected();
  },
  data() {
    return {
      menu: false,
      selectedItems: [],
    };
  },
  methods: {
    calculateSelected: function() {

      var items = [];
      for (var i = 0; i < this.booking.bookingAdditionalCharges.length; i++) {
        
        if (this.booking.bookingAdditionalCharges[i].enabled) {
          items.push(this.booking.bookingAdditionalCharges[i].internalID);
        }
      }

      this.selectedItems = items;
      console.log("Selected Items ")
      console.log(JSON.stringify(this.selectedItems));
    },
    getCostEstimate: function() {


      console.log("Changed" )
      console.log(JSON.stringify(this.selectedItems));

      for (var i = 0; i < this.booking.bookingAdditionalCharges.length; i++) { 
        if (this.selectedItems.indexOf(this.booking.bookingAdditionalCharges[i].internalID) == -1) {
          this.booking.bookingAdditionalCharges[i].enabled = false;
          this.booking.bookingAdditionalCharges[i].force = false;
        } else {
          this.booking.bookingAdditionalCharges[i].enabled = true;
          this.booking.bookingAdditionalCharges[i].force = true;
        }
      }

      this.$emit("getCostEstimate");
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">

.additionals .v-select__selections input { display: none}

.additionals {
  min-width: 150px;
}

</style>
